import { render, staticRenderFns } from "./Reasignar.vue?vue&type=template&id=5968a68c"
import script from "./Reasignar.vue?vue&type=script&lang=js"
export * from "./Reasignar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports